export default "__VITE_ASSET__DbvrXsjT__"